import { render, staticRenderFns } from "./FoodDistributionFeedback.vue?vue&type=template&id=664d7383&"
import script from "./FoodDistributionFeedback.vue?vue&type=script&lang=js&"
export * from "./FoodDistributionFeedback.vue?vue&type=script&lang=js&"
import style0 from "./FoodDistributionFeedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports